const actions = {
  SET_STATE: 'rewards/SET_STATE',
  FETCH_BUSINESS_EARN_REWARD_HISTORY: 'rewards/FETCH_BUSINESS_EARN_REWARD_HISTORY',
}

export default actions
